export default function (context) {
    if (context === document) {
        $(document).on('shown.bs.modal', function (e) {
            // console.log('bootstrap modal shown', $(e.target));
            $(e.target).find(':visible:focusable:first').focus()
        })

        $(document).on('hidden.bs.modal', function (e) {
            // console.log('bootstrap modal hidden', $(e.target));
            $('#menu-button').focus()
        })

        $(document).on('opened.cc.modal', function (e) {
            // console.log('bootstrap modal opened', $(e.target));
            $(e.target).find('.window-body :visible:focusable:first').focus()
        })

        $(document).on('close.cc.modal', function (e) {
            // console.log('bootstrap modal close', $(e.target));
            $('#menu-button').focus()
        })
    }
}
